import React from 'react';

import { HeroModal as StyledModal } from '@cavela/ui';

interface ModalProps {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  size?:
    | 'sm'
    | 'md'
    | 'lg'
    | 'xl'
    | '2xl'
    | 'full'
    | 'xs'
    | '3xl'
    | '4xl'
    | '5xl';
  children: React.ReactNode;
  scrollBehavior?: 'inside' | 'outside' | 'normal';
  hideCloseButton?: boolean;
  portalContainer?: string;
  className?: string;
  placement?:
    | 'top'
    | 'bottom'
    | 'center'
    | 'auto'
    | 'top-center'
    | 'bottom-center';
}

const Modal: React.FC<ModalProps> = ({
  scrollBehavior = 'normal',
  size = 'xl',
  hideCloseButton,
  className,
  portalContainer,
  placement = 'auto',
  ...props
}) => {
  return (
    <StyledModal
      {...props}
      placement={placement}
      scrollBehavior={scrollBehavior}
      size={size}
      classNames={{
        // Radix popups (e.g. the MarkdownEditor block type select) set
        // `pointer-events: none` on <body> while open, so the click that
        // dismisses them would land on <html>, which react-aria treats as
        // outside the modal and closes it. Keeping the dialog clickable
        // makes that click land inside it, closing only the popup.
        base: 'pointer-events-auto',
        closeButton:
          'rounded-xl top-4 right-4 border bg-white text-primary-text hover:bg-gray-2 border-gray-4 h-10 w-10 flex items-center justify-center z-[999]',
        body: 'overflow-y-auto'
      }}
      hideCloseButton={hideCloseButton}
      className={className}
    />
  );
};

export default Modal;
